import InnerComponent from '@Components/Production/ManualProductionEntry/ManualProductionEntryList';
import orgContainer from '@Components/AppContainer';

const ManualProductionEntryList = () => ((orgContainer(InnerComponent)));
export default ManualProductionEntryList;
